import { get, has } from 'lodash';

import { AccountService } from '../../../../account/AccountService';
import { REST } from '../../../../api/ApiService';
import { SETTINGS } from '../../../../config/settings';

export interface IBaseImage {
  id: string;
  shortDescription: string;
  detailedDescription: string;
  packageType: string;
  displayName: string;
}

export interface IBaseOsOptions {
  cloudProvider: string;
  baseImages: IBaseImage[];
}

export class BakeryReader {
  public static getRegions(provider: string): Promise<string[]> {
    if (has(SETTINGS, `providers.${provider}.bakeryRegions`)) {
      return Promise.resolve(get(SETTINGS, `providers.${provider}.bakeryRegions`));
    }
    return AccountService.getUniqueAttributeForAllAccounts(provider, 'regions').then((regions: string[]) =>
      regions.sort(),
    );
  }

  public static getBaseOsOptions(provider: string): Promise<IBaseOsOptions> {
    return this.getAllBaseOsOptions().then((options) => {
      return options.find((o) => o.cloudProvider === provider);
    });
  }

  private static getAllBaseOsOptions(): Promise<IBaseOsOptions[]> {
    return REST('/bakery/options').useCache().get();
  }

  public static getBaseLabelOptions(): Promise<string[]> {
    return Promise.resolve(['release', 'candidate', 'previous', 'unstable']);
  }
}
